// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_exn = require("rescript/lib/js/js_exn.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var UTCDate = require("../../common/types/UTCDate.bs.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");

function decode(obj) {
  var match = obj.eventType;
  return {
          id: obj.id,
          timestamp: Belt_Result.getExn(UTCDate.parseFromFloat(obj.timestamp)),
          eventType: match === "QUIET_SELLER_BROADCASTED" ? /* QuietSellerBroadcasted */0 : /* QuietBuyerBroadcasted */1
        };
}

var ppx_printed_query = "fragment ConversationEvent on ConversationEvent   {\nid  \ntimestamp  \neventType: type  \n}\n";

function parse(value) {
  var value$1 = Js_json.decodeObject(value);
  var tmp;
  if (value$1 !== undefined) {
    var value$2 = Caml_option.valFromOption(value$1);
    var value$3 = Js_dict.get(value$2, "id");
    var field_id = value$3 !== undefined ? Caml_option.valFromOption(value$3) : Js_exn.raiseError("Unexpected GraphQL query response");
    var value$4 = Js_dict.get(value$2, "timestamp");
    var field_timestamp = value$4 !== undefined ? Caml_option.valFromOption(value$4) : Js_exn.raiseError("Unexpected GraphQL query response");
    var value$5 = Js_dict.get(value$2, "eventType");
    var field_eventType = value$5 !== undefined ? (
        Caml_option.valFromOption(value$5) === "QUIET_SELLER_BROADCASTED" ? "QUIET_SELLER_BROADCASTED" : "QUIET_BUYER_BROADCASTED"
      ) : Js_exn.raiseError("Unexpected GraphQL query response");
    tmp = {
      id: field_id,
      timestamp: field_timestamp,
      eventType: field_eventType
    };
  } else {
    tmp = Js_exn.raiseError("Unexpected GraphQL query response");
  }
  return decode(tmp);
}

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var ConversationEvent = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  name: "ConversationEvent",
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

var Fragment;

exports.decode = decode;
exports.ConversationEvent = ConversationEvent;
exports.Fragment = Fragment;
/* UTCDate Not a pure module */
